import { Navigate } from 'react-router';
import Loadable from '../../components/Loadable';
import { lazy } from 'react';

//import { Outlet } from 'react-router';

const MyAccountPage = Loadable(lazy(() => import('../../pages/main/settings/MyAccountPage')));
const MyNotificationsPage = Loadable(lazy(() => import('../../pages/main/settings/MyNotificationsPage')));
const MyLanguageRegionPage = Loadable(lazy(() => import('../../pages/main/settings/MyLanguageRegionPage')));
const MyOrganizationsPage = Loadable(lazy(() => import('../../pages/main/settings/MyOrganizationsPage')));

//==== ORGANIZATION ====//
const OrganizationSettingsPage = Loadable(lazy(() => import('../../pages/main/settings/organization/OrganizationSettingsPage')));
const ResourcesLayout = Loadable(lazy(() => import('../../settings/organization/resources/ResourcesLayout')));
const TagsResourcePage = Loadable(lazy(() => import('../../settings/organization/resources/tags/TagsResourcePage')));
const StatusesResourcePage = Loadable(lazy(() => import('../../settings/organization/resources/statuses/StatusesResourcePage')));
const MembersLayout = Loadable(lazy(() => import('../../settings/organization/members/MembersLayout')));
const MembersPage = Loadable(lazy(() => import('../../settings/organization/members/members/MembersPage')));
const TeamsPage = Loadable(lazy(() => import('../../settings/organization/members/teams/TeamsPage')));
const OrganizationBillingPage = Loadable(lazy(() => import('../../pages/main/settings/organization/OrganizationBillingPage')));
const OrganizationSecurityPage = Loadable(lazy(() => import('../../pages/main/settings/organization/OrganizationSecurityPage')));

export const settingsRoutes = [
	{ path: '', element: <Navigate to={'my-account'} /> },
	{
		path: 'my-account',
		element: <MyAccountPage />,
	},
	{
		path: 'my-notifications',
		element: <MyNotificationsPage />,
	},
	{
		path: 'my-language-and-region',
		element: <MyLanguageRegionPage />,
	},
	{
		path: 'my-organizations',
		element: <MyOrganizationsPage />,
	},

	//==== ORGANIZATION ====//
	{
		path: ':organizationId/settings',
		element: <OrganizationSettingsPage />,
	},
	{
		path: ':organizationId/resources',
		element: <ResourcesLayout />,
		children: [
			{
				path: 'tags',
				element: <TagsResourcePage />,
			},
			{
				path: 'statuses',
				element: <StatusesResourcePage />,
			},
		],
	},
	{
		path: ':organizationId/members',
		element: <MembersLayout />,
		children: [
			{
				path: 'members',
				element: <MembersPage />,
			},
			{
				path: 'teams',
				element: <TeamsPage />,
			},
		],
	},
	{
		path: ':organizationId/billing',
		element: <OrganizationBillingPage />,
	},
	{
		path: ':organizationId/security',
		element: <OrganizationSecurityPage />,
	},
];
